import fly from './fly'

export const fetchHotword = () => fly.get('/mall/cs/goods/hotwords.json')

export const fetchSearchGoods = (params: Object) =>
  fly.get('/mall/common/search.json', params).then(res => res.data)
